import { PaymentRequestButton } from 'src/app/shared/components/payments';

import { useStripeWallet } from './useStripeWallet';

type Props = {
	height?: number;
};

export function StripeWallet({ height = 45 }: Props): JSX.Element | null {
	const { paymentType, ...rest } = useStripeWallet();
	if (paymentType === null) return null;
	return (
		<div className="w-full flex-1">
			<PaymentRequestButton {...rest} paymentType={paymentType} elementStyleOptions={{ height: `${height}px` }} />
		</div>
	);
}
